/**
 * Created by intellicar-rinas on 9/8/17.
 */
import $http from '../helpers/$http';
import {API_HOST} from '../constants/constants';
import apiHelper from '../helpers/apiHelper';

const UserAPIs = {

    login: (body) => {
        return $http.post(API_HOST + '/gettoken', body)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
    },

    immobilize : (body) => {
        return $http.post(API_HOST + '/api/commands/crankimmobilize', body)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
    },

    mobilize : (body) => {
        return $http.post(API_HOST + '/api/commands/crankmobilize', body)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
    },

    ignImmobilize : (body) => {
        return $http.post(API_HOST + '/api/commands/ignimmobilize', body)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
    },

    ignMobilize : (body) => {
        return $http.post(API_HOST + '/api/commands/ignmobilize', body)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
    },

    unlock : (body) => {
        return $http.post(API_HOST + '/api/commands/unlock', body)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
    },

    lock : (body) => {
        return $http.post(API_HOST + '/api/commands/lock', body)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
    },

    honk : (body) => {
        return $http.post(API_HOST + '/api/commands/honk', body)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
    },

    getVehCmdsPermList : (body) => {
        return $http.post(API_HOST + '/api/commands/getvehcmdsperm', body)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
    },

    setAssetTrackerBeaconFreq : (body) => {
        return $http.post(API_HOST + '/api/commands/setassettrackerbeaconfreq', body)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
    },

    getVehicleHistory : (body) => {
        return $http.post(API_HOST + '/api/commands/getvehiclehistory', body)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
    },

    getLafCmdHistory : (body) => {
        return $http.post(API_HOST + '/api/standard/cmdstatus', body)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
    },

    resolvePanicButtonAlert : (body) => {
        return $http.post(API_HOST + '/api/commands/resolvepanicbuttonalert', body)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
    },
    canImmobilize : (body) => {
        return $http.post(API_HOST + '/api/commands/canimmobilize', body)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
    },
    canMobilize : (body) => {
        return $http.post(API_HOST + '/api/commands/canmobilize', body)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
    },
    chargeDischargeControl : (body) => {
        return $http.post(API_HOST + '/api/commands/cancommand', body)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
    },
    orixImmobilize : (body) => {
        return $http.post('https://debug.intellicar.in/api/itriangle/command/ignimmobilizever2', body)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
    },
    orixMobilize : (body) => {
        return $http.post('https://debug.intellicar.in/api/itriangle/command/ignmobilizever2', body)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
    },
    outputAction : (body) => {
        return $http.post(API_HOST + '/api/commands/outputaction', body)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
    },
    standardImmobilize : (body) => {
        return $http.post(API_HOST + '/api/standard/immobilize', body)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
    },
    standardMobilize : (body) => {
        return $http.post(API_HOST + '/api/standard/mobilize', body)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
    },
    getBatteryCancmdInfos : (body) => {
        return $http.post(API_HOST + '/api/standard/getbatterycancmdinfos', body)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
    },
    listAllBulkcmds : (body) => {
        return $http.post(API_HOST + '/api/standard/listallbulkcmds' , body)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
    },
    listAllBulkCmdsDetails : (body) => {
        return $http.post(API_HOST + '/api/standard/listallbulkcmdsdetails' , body)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
    },
    bulkMobilize : (body) => {
        return $http.post(API_HOST + '/api/standard/bulkmobilize' , body)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
    },
    bulkImmobilize : (body) => {
        return $http.post(API_HOST + '/api/standard/bulkimmobilize' , body)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
    },
};
export default UserAPIs;